module.exports = __webpack_public_path__ + "static/media/kwikRide.1089605f.jpeg";